import { render, staticRenderFns } from "./PublicAuthLoginOverlay.vue?vue&type=template&id=23285aca&scoped=true&"
import script from "./PublicAuthLoginOverlay.vue?vue&type=script&lang=js&"
export * from "./PublicAuthLoginOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PublicAuthLoginOverlay.vue?vue&type=style&index=0&id=23285aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23285aca",
  null
  
)

export default component.exports